import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const deleteVehicle = createAsyncThunk(
  "vehicle/deleteVehicle",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const deliveryData = {
      vehicle_id: data.id,
    };

    const requestOptions = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deliveryData),
    };

    try {
      const response = await fetch(`${apiUrl}/delete_vehicle`, requestOptions);

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Deleting vehicle failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteVehicleSlice = createSlice({
  name: "vehicle",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    resetDeleteVehicleState: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteVehicle.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteVehicle.fulfilled, (state) => {
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteVehicle.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteVehicleState } = deleteVehicleSlice.actions;
export default deleteVehicleSlice.reducer;
